// extracted by mini-css-extract-plugin
export default {"container":"Qp-z","brandName":"Rp-z","productName":"Sp-z","productNamePdpEnhancements":"Tp-z","breakLongProductName":"Up-z"};